/**
 * +jump: the hop (Space), shared by every hero: a quick crouch-spring, knees tucked and arms up at
 * the top of the arc, legs reaching down for the landing (the sim's 0.6 s arc lifts the unit; the
 * renderer adds the height). Full-body mask so the tuck shows while running too; dust on the
 * take-off and the landing.
 */
import { type PoseDef, defineClip } from '../clips';
import { registerAbilityClips } from '../registry';

/** Pseudo ability id the frame cue uses for a jump (game/frame.ts eventsToCues). */
export const JUMP_CLIP_ID = 'common.jump';

const TUCK: PoseDef = {
  spine: [0.12, 0, 0],
  head: [-0.1, 0, 0],
  leftUpperLeg: [0.85, 0, 0.05],
  rightUpperLeg: [0.55, 0, -0.05],
  leftLowerLeg: [1.25],
  rightLowerLeg: [1.0],
  rightUpperArm: [-0.25, 0, 0.9],
  leftUpperArm: [-0.25, 0, 0.9],
  rightLowerArm: [0.5],
  leftLowerArm: [0.5],
};

const REACH: PoseDef = {
  spine: [0.05, 0, 0],
  leftUpperLeg: [0.25, 0, 0],
  rightUpperLeg: [0.1, 0, 0],
  leftLowerLeg: [0.35],
  rightLowerLeg: [0.25],
  rightUpperArm: [-0.15, 0, 0.6],
  leftUpperArm: [-0.15, 0, 0.6],
};

export const jump = defineClip({
  id: JUMP_CLIP_ID,
  duration: 0.66,
  blendIn: 0.03,
  mask: 'full',
  keys: [
    { t: 0.08, ease: 'snap', pose: TUCK },
    { t: 0.32, ease: 'linear', pose: TUCK },
    { t: 0.54, ease: 'out', pose: REACH },
    { t: 0.66, ease: 'out' },
  ],
  cues: [
    { t: 0.02, fx: 'dust', at: 'ground', scale: 0.55 },
    { t: 0.6, fx: 'dust', at: 'ground', scale: 0.85 },
  ],
});

export function registerJumpClip(): void {
  registerAbilityClips(JUMP_CLIP_ID, { strike: jump });
}
